export enum Product {
    IDTAG = "idtag",
    KEYKEEPER = "keykeeper",
  }
  